import { AreaChart } from "recharts";
import styled from "styled-components";

export const BigChartContainer = styled.div``;
export const BigChartWrapper = styled.div``;
export const ThirdChart = styled.div`
  border-radius: 10px;
  padding: 20px;
`;
export const ChartBigPrice = styled.div`
  font-family: Inter;
  font-size: 60px;
  font-weight: 700;
  line-height: 73px;
  letter-spacing: 0em;
  /* text-align: left; */
  color: #0e0e0e;
`;
export const ChartBigAmount = styled.div`
  /* border: 1px solid red; */
  width: 25%;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;
export const ChartAmountContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const ChartBigPercent = styled.div`
  width: 48px;
  height: 28px;
  border-radius: 5px;
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  color: #5e5e5e;
`;
export const ChartInnerDiv = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.02em;
`;
export const ChartFlow = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #0e0e0e;
  display: flex;
  gap: 10px;
  align-items: center;
`;
export const ChartFlowDiv = styled.div`
  width: 100px;
  /* border: 1px solid red; */
  justify-content: center;
`;
export const ChartFlowContainer = styled.div`
  /* width: 100%; */
  display: flex;
  justify-content: center;
  margin-left: 15%;
  /* position: absolute; */
  /* border: 1px solid red; */
`;
export const ChartFlowContent = styled.div`
  display: flex;
  flex-direction: row;
  /* border: 1px solid red; */
`;
export const Circle = styled.div`
  width: 8px;
  height: 8px;
  background-color: #00c703;
  border-radius: 50%;
`;
export const Circle01 = styled.div`
  width: 8px;
  height: 8px;
  background-color: #09005b;
  border-radius: 50%;
`;
export const ChartFlowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  /* border: 1px solid red; */
  /* width: 200px; */
  /* justify-content: ; */
`;

export const ChartBigData = styled.div``;

export const StyledAreaChart = styled(AreaChart)`
  width: 1000px; /* Set width to 100% for mobile */

  @media only screen and (min-width: 768px) {
    width: 500px; /* Set width to 80% for desktop */
    margin: 0 auto; /* Center align on larger screens */
  }

  /* Add any additional styles as needed */
`;

// export const ThirdChart = styled.div`
//   border-radius: 10px;
//   padding: 20px;
// `;
